import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
    mutation PortalLogin($accountNumber: String!, $password: String!) {
        portalLogin(accountNumber: $accountNumber, password: $password) {
            token
            accountNumber
            mustChangePassword
            hasSettlementAccount
        }
    }
`;

export const LOGOUT_MUTATION = gql`
    mutation PortalLogout {
        portalLogout
    }
`;

export const CHANGE_PASSWORD_MUTATION = gql`
    mutation PortalChangePassword($oldPassword: String!, $newPassword: String!) {
        portalChangePassword(oldPassword: $oldPassword, newPassword: $newPassword)
    }
`;
